import { post } from './httpRequest';

const sendEnquiry = async () => {
  await post(`/brandup/enquiry`, {});
};
export default sendEnquiry;
